import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { GridApi, ColDef, ColumnApi, PaginationChangedEvent, RowClickedEvent } from 'ag-grid-community';
import { NgbDateStruct, NgbCalendar, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';
import { UnblockService } from 'src/app/_services/unblock.service';
import { MenusService } from 'src/app/_services/menu.service';
import { Location } from '@angular/common';
import { BtnCellRenderer1 } from 'src/app/common/button-cell-renderer.component1';
import { BtnCellRenderer } from 'src/app/common/button-cell-renderer.component';
import { CustomerService } from 'src/app/views/pages/customers/customer-service';
import { UserService } from 'src/app/_services/user.service';
import { MerchantFilter, MerchantService } from 'src/app/views/pages/merchants/merchant-master/merchant.service';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { Column, FilterChangedEvent, FilterModifiedEvent, FilterOpenedEvent, GridReadyEvent } from 'ag-grid-community';
import { PiiCellRendererComponent } from 'src/app/common/pii-cell-renderer.component';
import { PiiGridService } from 'src/app/_services/pii-grid.service';
import { UnblockRequestModalComponent } from 'src/app/common/unblock-request/unblock-request-modal.component';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import Swal from 'sweetalert2';
import { AlertService } from 'src/app/_services/alert.service';
import { UserDashboardService } from 'src/app/views/pages/user-dashboard/user-dashboard.service'
import { firstValueFrom } from 'rxjs';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';


const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx'


export interface IMerchantData {
  "name": string,
  "merchantId": string,
  "businessName": string,
  "contactperson": string,
  "id": number,
  "contactno": string,
  "emailid": string,
  "state": string,
  "city": string,
  "isdeleted": string
}
export interface CustomerBlockFilter {
  "columns"?: any;
  "fullname"?: string,
  "mobile"?: string,
  "startDate"?: string,
  "endDate"?: string,
  "pageRecords"?: number,
  "pageNumber"?: number,
  "emailId"?: string,
  "Status"?: string,
  "KycStatus"?: string;
  "emiratesId"?: string;

}
@Component({
  selector: 'app-block-entity-management',
  templateUrl: './block-entity-management.component.html',
  styleUrls: ['./block-entity-management.component.scss']
})

export class BlockEntityManagementComponent implements OnInit {

  @ViewChild('modalBlockedEntity') modalBlockedComponent: ModalComponent;
  @ViewChild('modalReportCustomer') private modalReportComponent: ModalComponent;
  @ViewChild('modalUnblockRequest') private modalUnblockRequestComponent: ModalComponent;
  @ViewChild('unblockRequestInner') private unblockRequestInner: UnblockRequestModalComponent;
  @Output() ScreeningReportEvent: EventEmitter<any> = new EventEmitter<any>();
  @Output() BlockedmerchantSelectEvent: EventEmitter<any> = new EventEmitter<any>();
  isInitiator = true;
  public gridApi!: GridApi;
  public rowData!: IMerchantData[];
  public customerRowData!: CustomerBlockFilter[];
  public gridColumnApi!: ColumnApi;
  public isSearching:boolean = true;
  public quickFilterShow:boolean = false;
  public globalSearch: string = '';

  public searchMerName: string;
  public searchMID: string;
  public resellerPartnerId: string;
  public Status: string;
  public searchFromDate: NgbDateStruct;
  public searchToDate: NgbDateStruct;
  public fullName: string;
  public mobileNumber: string;
  public emailId: string;
  public pageNumber: number = 0;
  collectiondata: number = 0;
  collectionSize: number = 0;
  selectedCustomer: any = null;
  image: any;

  public entityName: string;
  public entityId: string;
  public searchEmailId: string;
  public pageSize: number = 10;
  public totalRecords: number = 0;
  public searchTLN: string;
  public searchMobile: string;
  public searchMid: string;
  type: string = 'CUSTOMER'; // or 'MERCHANT'
  public permissions: any = '';
  customerNumber: string = '';
  walletId: string = '';
  emiratesId: string = '';
  merchantId: string = '';
  defaultColDef: any = {};
  pageSizeArr: number[] = [10, 25, 50, 100];
  currentPage: number = 1;
  modalConfigUnblockRequestForm: ModalConfig;
  modalConfigBlocked: any = {};
  modalConfigReport: any = {};
  tableInfo: any = {};
  requestsVisible: boolean = false;
  unblockRequests: any[] = [];
  requestsCurrentPage = 1;
requestsCollectionSize = 0;
requestsPageSize = 10;

  public unblockColumnDefs: ColDef[] = [
    { field: 'fullName', headerName: 'Full Name',  lockVisible: true, resizable: true, cellRenderer: 'agGroupCellRenderer' },
    { field: 'contactNumber', headerName: 'Contact No.',  lockVisible: true},
    { field: 'emiratesId', headerName: 'Emirates ID', width: 250, minWidth: 200 },
    { field: 'nationality', headerName: 'Nationality', lockVisible: true },
    { field: 'requestID', headerName: 'Request ID', width: 250, minWidth: 200},
    { field: 'requestedOn', headerName: 'Requested On',  lockVisible: true, valueFormatter: (p) => new Date(p.value).toLocaleString() },
    { field: 'submittedBy', headerName: 'Submitted By',  lockVisible: true },
    { field: 'approvedOn', headerName: 'Approved On',  lockVisible: true, valueFormatter: (p) => p.value ? new Date(p.value).toLocaleString() : '-' },
    { field: 'approvedBy', headerName: 'Approved By',  lockVisible: true, valueGetter: (p) => p.data.approvedBy || '-' },
    { field: 'status', headerName: 'Status',  lockVisible: true },{
    colId: 'unblock',
    field: 'unblock',
    headerName: 'Unblock Request',
    lockVisible: true,
    width: 180,
    cellRenderer: BtnCellRenderer,
    cellRendererParams: [
      {
        clicked: (event: any, param: any) => {
          this.selectedCustomer = param.data;
          this.unblockRequestInner.customerData = this.selectedCustomer;
          this.modalConfigUnblockRequestForm.modalTitle =
            this.permissions.includes('Approve') ? 'Approve Unblock Request' : 'Initiate Unblock Request';
          this.modalUnblockRequestComponent.open();
        },
        buttonIconClass: 'icon-user-check',
        buttonVisible: true
      }
    ]
  }
];

  public MerchantcolumnDefs: ColDef[] = [
    { field: 'fullName', headerName: 'Merchant Name', lockVisible: true, resizable: true, cellRenderer: 'agGroupCellRenderer' },
    { field: 'shareHolderHit', headerName: 'Shareholder/UBO', lockVisible: true, cellRenderer: PiiCellRendererComponent, width: 250, minWidth: 200 },
    { field: 'tradeName', headerName: 'Contact Name', lockVisible: true, },
    { field: 'userType', headerName: 'Entity Type', lockVisible: true, },
    { field: 'identifier', headerName: 'Identifier', lockVisible: true, },
    { field: 'emiratesId', headerName: 'Emirates Id', lockVisible: true, cellRenderer: PiiCellRendererComponent, width: 250, minWidth: 200 },
    { field: 'userId', headerName: 'ID', hide: true, lockVisible: true, },
    { field: 'mobileNumber', headerName: 'Contact No', lockVisible: true, },
    { field: 'emailId', headerName: 'Email ID', lockVisible: true, },
    { field: 'onboardedOn', headerName: 'Onboarded On', lockVisible: true, },
    { field: 'onboardedBy', headerName: 'Onboarded By', lockVisible: true, },
    { field: 'walletStatus', headerName: 'Status', lockVisible: true, },
    { field: 'documentVerifyStatus', headerName: 'KYC Document Status', lockVisible: true, },

    { field: 'kycStatus', headerName: 'Screening Status', lockVisible: true },
    { field: 'currentTrack', headerName: 'Current Track', lockVisible: true },
    {
      field: 'screening', headerName: 'Screening Report', lockVisible: true, width: 30, cellRenderer: BtnCellRenderer1, cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            this.tableInfo = param.data.userId
            this.customerService.getCustomerPdfById(this.tableInfo)
              .subscribe((data: any) => {
                var reader = new FileReader();
                reader.readAsDataURL(data.body);
                new Promise((resolve, reject) => {
                  reader.onloadend = function () {
                    resolve(reader.result);
                  }
                }).then(data => {
                  this.image = data;
                  this.ScreeningReportEvent.emit(data);
                  return this.modalReportComponent.open();
                });
              })
          },
          buttonIconClass: 'icon-eye',
          buttonVisible: true
        },
        {
          clicked: async (event: any, param: any) => {
            this.tableInfo = param.data.userId
            this.customerService.getCustomerPdfById(this.tableInfo)
              .subscribe((data: any) => {
                console.log(data);
                var reader = new FileReader();
                reader.readAsDataURL(data.body);
                new Promise((resolve, reject) => {
                  reader.onloadend = function () {
                    resolve(reader.result);
                  }
                }).then(data => {
                  this.image = data;
                });
              })
          },
          buttonIconClass: 'icon-arrow-down',
          buttonVisible: true
        },
      ]
    },
    {
      field: 'unmasking', headerName: 'Unmasking', lockVisible: true, width: 120, cellRenderer: BtnCellRenderer1, cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            this.piiGridService.unmaskRow(param.data, this.gridApi);
          },
          buttonIconClass: 'icon-frame-1',
          buttonText: '',
          buttonVisible: true, 
          customImage: 'assets/images/unmask-icon.png'
        }
      ]
    },
    {
      field: 'actions', headerName: 'Actions', lockVisible: true, width: 120, cellRenderer: BtnCellRenderer1, cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            this.tableInfo = param.data.userId
            console.log("Clicked Data :" + JSON.stringify(param.data.userId));
            this.BlockedmerchantSelectEvent.emit({
              mobile: param.data.userId,
              walletStatus: param.data.walletStatus
            });
            return await this.modalBlockedComponent.open();
          },
          buttonIconClass: 'icon-settings',
          buttonVisible: true
        }
      ]
    },
    {
      field: 'posRequest', headerName: 'POS Request', lockVisible: true, width: 30, cellRenderer: BtnCellRenderer1, cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            this.posRequest(param.data);
          },
          buttonIconClass: 'icon-smartphone',
          buttonVisible: false
        }
      ]
    },
  ];

  public columnDefs: ColDef[] = [
    { field: 'fullName', headerName: 'Fullname', lockVisible: true, resizable: true, cellRenderer: 'agGroupCellRenderer' },
    { field: 'mobileNumber', headerName: 'Contact No', lockVisible: true, },
    { field: 'emiratesId', headerName: 'Emirates ID', lockVisible: true, cellRenderer: PiiCellRendererComponent, width: 250, minWidth: 200 },
    {
      field: 'eidExpiryDate', headerName: 'Emirates ID Expiry Date', lockVisible: true, valueFormatter: (params: any) => {
        if (params.value != null) {
          const date = new Date(params.value);
          console.log(date);
          return date.toLocaleDateString().split('T')[0];
        }
        return ''
      }
    },
    { field: 'id', headerName: 'ID', hide: true },
    { field: 'nationality', headerName: 'Nationality', lockVisible: true, },
    { field: 'emailId', headerName: 'Email ID', lockVisible: true, },
    { field: 'screeningId', headerName: 'Screening ID', lockVisible: true, },
    { field: 'screeningProviderCode', headerName: 'Screening Provider Code', lockVisible: true, },
    { field: 'createdOn', headerName: 'Created On', lockVisible: true, },
    { field: 'walletStatus', headerName: 'Wallet Status', lockVisible: true, },
    { field: 'kycStatus', headerName: 'KYC Status', lockVisible: true, },
    { field: 'currentTrack', headerName: 'Current Track', lockVisible: true, },
    { field: 'remark', headerName: 'Remark', lockVisible: true, },
    {
      field: 'actions', headerName: 'Screening Report', lockVisible: true, width: 180, cellRenderer: BtnCellRenderer, cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            this.tableInfo = param.data.userId
            this.merchantService.viewCustomerReport(this.tableInfo)
              .subscribe((data) => {
                const reader = new FileReader();
                reader.readAsDataURL(data.body);
                new Promise((resolve) => {
                  reader.onloadend = function () { resolve(reader.result); }
                }).then(data => {
                  this.image = data;
                  this.ScreeningReportEvent.emit(data);
                  return this.modalReportComponent.open();
                });
              })
          },
          buttonIconClass: 'icon-eye'
        },
        {
          clicked: async (event: any, param: any) => {
            this.tableInfo = param.data.userId
            this.merchantService.viewCustomerReport(this.tableInfo)
              .subscribe((data) => {
                const reader = new FileReader();
                reader.readAsDataURL(data.body);
                new Promise((resolve) => {
                  reader.onloadend = function () { resolve(reader.result); }
                }).then(data => {
                  this.image = data;
                  //this.downloadPdf(data, param.data.fullName);
                });
              })
          },
          buttonIconClass: 'icon-arrow-down'
        }
      ]
    },
    {
      colId: 'unmasking', field: 'unmasking', headerName: 'Unmasking', lockVisible: true, width: 120, cellRenderer: BtnCellRenderer1, cellRendererParams: [
        {
          clicked: async (event: any, param: any) => {
            this.piiGridService.unmaskRow(param.data, this.gridApi);
          },
          buttonIconClass: 'icon-frame-1',
          buttonText: '',
          buttonVisible: true,
          customImage: 'assets/images/unmask-icon.png'
        }
      ]
      //   },
      //   {
      //   colId: 'unblock', 
      //   field: 'unblock', 
      //   headerName: 'Unblock Request', 
      //   lockVisible: true, 
      //   width: 180, 
      //   cellRenderer: BtnCellRenderer, 
      //   cellRendererParams: [
      //     {
      //       clicked: (event: any, param: any) => {
      //    this.selectedCustomer = param.data;

      //         // Pass data to modal and open
      //             this.selectedCustomer = param.data;

      //     // Pass data to inner component and open modal
      //     this.unblockRequestInner.customerData = this.selectedCustomer;
      //          this.modalConfigUnblockRequestForm.modalTitle =
      //           this.permissions.includes('Approve')
      //             ? 'Approve Unblock Request'
      //             : 'Initiate Unblock Request';
      //      this.modalUnblockRequestComponent.open();


      //       },
      //       buttonIconClass: 'icon-user-check', // human outline with tick
      //       buttonVisible: true
      //     }
      //   ]
    }

    ,
    // {field: 're_kyc_day',tooltipField: 're_kyc_day', headerName: 'Re KYC Date',},
    // {field: 'city', tooltipField: 'city', headerName: 'City',hide: true},
    // {field: 'created_on', headerName: 'Created On Formatted',  filter: 'agDateColumnFilter', valueFormatter: dateFormatter},
    // {field: 'status', headerName: 'Status Formatted', minWidth: 120, valueFormatter: statusFormatter},
    // {field: 'actions',headerName: 'Actions', width: 180, cellRenderer: BtnCellRenderer, cellRendererParams: [
    //    {
    //       clicked: async (event: any, param: any) => {
    //         this.tableInfo = param.data.registeredMobile
    //         console.log("Row clicked :"+this.tableInfo);
    //         var mobile = this.tableInfo;
    //         console.log("Mobile :"+mobile);


    //   this.merchantService.customerStatusApprove(mobile)
    //   .subscribe((data) => {
    //     console.log("Response"+JSON.stringify(data));
    //     this.alertService.successAlert(JSON.stringify(data.text));
    //     window.location.reload();
    //     })
    //   }

    //     this.BlockedmerchantSelectEvent.emit(mobile);
    //     return await this.modalblockedComponent.open();

    //   },
    //   buttonIconClass: 'icon-settings'
    // },
    // {
    //   clicked: async (event: any, param: any) => {
    //     this.tableInfo = param.data.registeredMobile
    //     console.log("Row clicked :"+this.tableInfo);
    //     var mobile = this.tableInfo;
    //     console.log("Mobile :"+mobile);
    //     if(window.confirm("Do you want to reject this "+param.data.fullName+" customer")){
    //       //put your delete method logic here

    //       this.merchantService.customerStatusReject(mobile)
    //       .subscribe((data) => {
    //         console.log("Response"+JSON.stringify(data));
    //         this.alertService.successAlert(JSON.stringify(data.text));
    //         window.location.reload();
    //         })

    //     }

    //     // this.BlockedmerchantSelectEvent.emit(this.tableInfo);
    //     // return await this.modalblockedComponent.open();

    //   },
    //   buttonIconClass: 'icon-x'
    // }
    //   ]
    // }
  ];



  // public rowData: any[] = [];

  columnDefsCopy: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];
  tableSelectedColumn: ColDef[] = [...(this.columnDefs.filter((col) => !col?.hide))];

  public unblockRowData: any[] = [];
  constructor(
    private userDashboardService: UserDashboardService,
    private alertService: AlertService,
    private piiGridService: PiiGridService,
    private merchantService: MerchantService,
    private menuService: MenusService,
    private location: Location,
    private blockEntityService: UnblockService,
    private ngbCalendar: NgbCalendar,
    private ngbDateParserFormatter: NgbDateParserFormatter,
    private unblockService: UnblockService,
    private customerService: CustomerService,
    private userService: UserService
  ) {
    this.searchFromDate = this.ngbCalendar.getToday();
    this.searchToDate = this.ngbCalendar.getToday();

    this.modalConfigUnblockRequestForm = {
      modalTitle: this.permissions.includes('Approve') ? "Approve Unblock Request" : "Initiate Unblock Request",
      modalSize: 'xl',
      hideCloseButton(): boolean {
        return true;
      },
      hideDismissButton(): boolean {
        return true
      }
    }
  }

  // getDataByType(type: string) {
  //   console.log("Selected type:", type);
  //   this.type = type; // update the current type so UI reflects it
  //   // call your API or filter data based on type
  // }

  getDataByType(type: string) {
    this.type = type;

    if (type === 'CUSTOMER') {
      this.loadCustomerBlockedList();
      this.gridApi.setColumnDefs(this.columnDefs); // Customer columns
    } else if (type === 'MERCHANT') {
      this.loadMerchantBlockedList();
      this.gridApi.setColumnDefs(this.MerchantcolumnDefs); // Merchant columns
    }

    this.requestsVisible = false;
    // Clear previous rows before loading new data
    this.gridApi.setRowData([]);
  }


  loadCustomerBlockedList() {
    this.customerService.getCustomerBlockedList(
      this.fullName || '',
      this.mobileNumber || '',
      '', '',
      this.pageSize,
      this.pageNumber
    ).subscribe((data: any) => {
      this.rowData = data.content;
      this.collectiondata = data.content;
      this.collectionSize = data.totalElements;
      this.gridApi.setRowData(this.rowData);
    });
  }

  loadMerchantBlockedList() {
    const filter: MerchantFilter = {};
    this.merchantService.getBlockedMerchantList(
      this.searchMid || '',
      this.searchMobile || '',
      this.searchMerName || '',
      this.searchEmailId || '',
      this.Status || '',
      this.resellerPartnerId || '',
      this.searchTLN || '',
      filter,
      this.pageSize,
      this.pageNumber
    ).subscribe((data: any) => {
      this.rowData = data.content.map((row: any) => ({
        ...row,
        reviewFlag: row.walletStatus === 'ACTIVE' && row.posEnable === false
      }));
      this.collectiondata = data.content;
      this.collectionSize = data.totalElements;
      this.gridApi.setRowData(this.rowData);
    });
  }


  ngOnInit(): void {
     if(this.isSearching)
       {
         this.refreshGrid();
         this.isSearching=true;
       }
    const path = this.location.prepareExternalUrl(this.location.path());

    this.permissions = this.menuService.getPermissions(path);
    this.tableSelectedColumn = [...(this.columnDefs.filter((col) => !col?.hide))];
  }




  updateSelectedColumn(event: any) {
    if (event.target.checked) {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) < 0) {
        // this.tableSelectedColumn.push(this.columnDefs[parseInt(event.target.value)]);
        this.tableSelectedColumn.splice(parseInt(event.target.value), 0, this.columnDefsCopy[parseInt(event.target.value)]);
      }
    } else {
      if (this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]) > -1) {
        this.tableSelectedColumn.splice(this.tableSelectedColumn.indexOf(this.columnDefsCopy[parseInt(event.target.value)]), 1);
      }
    }
    this.gridApi.setColumnDefs(this.tableSelectedColumn)
    this.gridApi.setDefaultColDef(this.defaultColDef);
  }

  quickFilterShowAction(event: any) {
    this.quickFilterShow = !this.quickFilterShow;
    if (!this.quickFilterShow) {
      this.searchFromDate = this.ngbCalendar.getToday();
      this.searchToDate = this.ngbCalendar.getToday();
      this.refreshGrid();
    }
  }

async onSearchBtnClick(event: Event) {
  if (this.customerNumber && !/^\d+$/.test(this.customerNumber)) {
    this.alertService.errorAlertWithMessage("Enter valid mobile number");
    this.customerNumber='';
    return;
  }
  this.currentPage = 1;
  this.pageNumber = 0;
     this.isSearching=false;

  try {
    const walletIdVal = this.walletId?.trim() || "";

    // Fetch ID only if wallet search is used
    let fetchedId = "";
    if (walletIdVal) {
      fetchedId = this.extractUserId(
        await firstValueFrom(
          this.userDashboardService.getUserId("WALLET", walletIdVal, this.type)!
        )
      );
    }

    if (this.type === 'CUSTOMER') {
      const fullNameVal = this.fullName || "";
      const mobileNumber = this.customerNumber || "";
      const emiratesId = this.emiratesId || "";
      const id=fetchedId || "";

         if (emiratesId) {
      this.customerService
        .getCustomerByEmiratesId(
          fullNameVal,
          mobileNumber,
          emiratesId,
          "",      // dateFrom
          "",      // dateTo
          this.pageSize,
          this.pageNumber
        )
        .subscribe((resp: any) => {
          const list = resp?.content || [];

          if (!list.length) {
            this.alertService.errorAlertWithMessage("No records present");
            this.gridApi.setRowData([]);
            return;
          }

          this.customerRowData = [...list];
          this.collectionSize = list.length;
          this.gridApi.setRowData(list);
        });

      return; 
    }

    this.customerService
      .getCustomerBlockedList(
        fullNameVal,
        mobileNumber,
        "",         // dateFrom
        "",         // dateTo
        this.pageSize,
        this.pageNumber,
        "",         // walletId (not needed here)
        "",         // emiratesId
        fetchedId   // wallet fetched userId
      )
      .subscribe((data: any) => {
let filtered = data.content;
console.log("ccccccccccccccccccccccccccccccccc")
if (walletIdVal && walletIdVal.trim() !== "") {
  filtered = filtered.filter((c: any) => c.userId === fetchedId);
}
        if (!filtered.length) {
          this.alertService.errorAlertWithMessage("No records present");
          this.gridApi.setRowData([]);
          return;
        }

        this.customerRowData = [...filtered];
        this.collectionSize = filtered.length;
        this.gridApi.setRowData(filtered);
      });



    } else if (this.type === 'MERCHANT') {
      const filterData: MerchantFilter = {};
      const mid = this.merchantId || '';
      const mobile = this.mobileNumber || '';
      const fullName = this.fullName || '';
      const emailId = this.emailId || '';
      const status = this.Status || '';
      const kycStatus = '';
      const tradeNumber = '';
      const id=fetchedId;

      this.merchantService.getBlockedMerchantList(
        mid,
        mobile,
        fullName,
        emailId,
        status,
        kycStatus,
        tradeNumber,
        filterData,
        this.pageSize,
        this.pageNumber,
        id
      ).subscribe((data: any) => {
        let filtered = data.content;

if (walletIdVal && walletIdVal.trim() !== "") {
  filtered = filtered.filter((c: any) => c.userId === fetchedId);
}
        if (!filtered.length) {
          this.alertService.errorAlertWithMessage("No records present");
          this.gridApi.setRowData([]);
        } else {
          this.rowData = filtered.map((row: any) => ({
            ...row,
            reviewFlag: row.walletStatus === 'ACTIVE' && !row.posEnable
          }));
          this.collectiondata = filtered;
          this.collectionSize = filtered.length;
          this.gridApi.setRowData(this.rowData);
        }
      });
    }
  } catch (error) {
    console.error("Search error:", error);
    this.alertService.errorAlertWithMessage("Something went wrong while fetching records");
  }
}


  extractUserId(resp: any) {
    if (resp != null && resp.response != null) {
      var response = resp.response;
      if (response.status == 200) {
        return response.data;
      }
    }
    return null;
  }

  closeModalBlocked($event: any) {
    if (!$event.showModal) {
      this.modalBlockedComponent.close();
      this.refreshGrid();
    }
  }

  resetFilter() {
  // Clear all search fields
  this.searchMerName = '';
  this.searchMID = '';
  this.resellerPartnerId = '';
  this.Status = '';
  this.searchFromDate = this.ngbCalendar.getToday();
  this.searchToDate = this.ngbCalendar.getToday();
  this.fullName = '';
  this.mobileNumber = '';
  this.emailId = '';
  this.customerNumber = '';
  this.walletId = '';
  this.emiratesId = '';
  this.searchTLN = '';
  this.searchMobile = '';
  this.searchMid = '';
  this.searchEmailId = '';

  // Reset page
  this.pageNumber = 0;
  this.currentPage = 1;

  // Clear quick filter (AG Grid)
  if (this.gridApi) {
    this.gridApi.setQuickFilter('');
  }

  // Reload data
  if (this.type === 'CUSTOMER') {
    this.loadCustomerBlockedList();
  } else {
    this.loadMerchantBlockedList();
  }
}

  onGridReady(params: GridReadyEvent<IMerchantData>) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;

      const unblockColumn = {
        colId: 'unblock',
        field: 'unblock',
        headerName: 'Unblock Request',
        lockVisible: true,
        width: 180,
        cellRenderer: BtnCellRenderer,
        cellRendererParams: [
          {
            clicked: (event: any, param: any) => {
              this.selectedCustomer = param.data;
              this.unblockRequestInner.customerData = this.selectedCustomer;
              this.modalConfigUnblockRequestForm.modalTitle =
                this.permissions.includes('Approve')
                  ? 'Approve Unblock Request'
                  : 'Initiate Unblock Request';
              this.modalUnblockRequestComponent.open();
            },
            buttonIconClass: 'icon-user-check',
            buttonVisible: true
          }
        ]
      };

      
    const unblockColExistsCustomer = this.columnDefs.some(col => col.colId === 'unblock');
  if (!unblockColExistsCustomer &&  !this.permissions.includes('Approve') ) {
    this.columnDefs.push(unblockColumn);
  }

      const unblockColExistsMerchant = this.MerchantcolumnDefs.some(col => col.colId === 'unblock');
      if (!unblockColExistsMerchant && !this.permissions.includes('Approve')) {
        this.MerchantcolumnDefs.push(unblockColumn);
      }
    

    this.gridApi.setColumnDefs(this.columnDefs);
  }
allowOnlyDigits(event: KeyboardEvent) {
  const charCode = event.which ? event.which : event.keyCode;
  if (charCode < 48 || charCode > 57) {
    event.preventDefault();
  }
}


   
refreshGrid() {
  if (this.requestsVisible) {
    this.loadRequests();
  } else if (this.type === 'CUSTOMER') {
    this.loadCustomerBlockedList();
  } else if (this.type === 'MERCHANT') {
    this.loadMerchantBlockedList();
  }
}

  onPaginationChange(param: PaginationChangedEvent | any) {
    this.pageNumber = param - 1;
    this.refreshGrid();
  }

  posRequest(data: any) {
    console.log(data);
    Swal.fire({
      title: 'Are you sure you want to request for POS this merchant ' + data?.fullName + '?',
      showCancelButton: true,
      confirmButtonText: 'Confirm',
      cancelButtonText: 'Cancel',
    }).then((result) => {
      if (result.isConfirmed) {
        //Call API for POS
        console.log(data.userId)
        this.merchantService.sendPOSRequest(data.userId).subscribe((response: any) => {
          console.log(response);
          if (response.response.status == 200) {
            Swal.fire('Your POS Request sent successfully', '', 'success');

            const filter: MerchantFilter = {}
            console.log(this.ngbDateParserFormatter.format(this.searchFromDate))
            if (this.searchMerName == null || this.searchMerName == "") {
              this.searchMerName = "";
            }
            if (this.ngbDateParserFormatter.format(this.searchFromDate) == "0-00-00") {
              filter.startDate = "";
            } else {
              filter.startDate = this.ngbDateParserFormatter.format(this.searchFromDate);
            }
            if (this.ngbDateParserFormatter.format(this.searchToDate) == "0-00-00") {
              filter.endDate = "";
            } else {
              filter.endDate = this.ngbDateParserFormatter.format(this.searchToDate);
            }

            this.merchantService.getBlockedMerchantList(this.searchMid, this.searchMobile, this.searchMerName, this.searchEmailId, this.Status, this.resellerPartnerId, this.searchTLN, filter, this.pageSize, this.pageNumber)
              .subscribe((data) => {
                this.rowData = data.content.map((row: any) => ({
                  ...row,
                  reviewFlag: row.walletStatus === 'ACTIVE' && row.posEnable === false
                }));
                this.collectiondata = data.content
                this.collectionSize = data.totalElements
                this.totalRecords = data.content
              });
            return;
          }
          Swal.fire(response.response.message, '', 'error');
        })
      }
    });
  }


  onPageSizeChanges($event: Event) {
    this.gridApi.paginationSetPageSize(this.pageSize)
    this.gridApi.applyTransaction({ remove: this.rowData })
    this.gridApi.showLoadingOverlay();
    const filter: CustomerBlockFilter = {}
    if (this.searchMerName) filter.fullname = this.searchMerName ? this.searchMerName : "";
    if (this.searchMID || '') filter.mobile = this.searchMID || '';
    if (this.Status || "") filter.Status = this.Status || '';
    if (this.resellerPartnerId) filter.KycStatus = this.resellerPartnerId || '';
    if (this.searchFromDate) filter.startDate = this.ngbDateParserFormatter.format(this.searchFromDate);
    if (this.searchToDate) filter.endDate = this.ngbDateParserFormatter.format(this.searchToDate);
    if (this.emailId) filter.emailId = this.emailId;
  
    if (this.fullName == "" || this.fullName == undefined) {
      this.fullName = "";
    }
    if (this.mobileNumber == "" || this.mobileNumber == undefined) {
      this.mobileNumber = "";
    }
    if (this.emailId == "" || this.emailId == undefined) {
      this.emailId = "";
    }
    return this.customerService.getCustomerBlockedList(this.fullName, this.mobileNumber, "", "", this.pageSize, this.pageNumber)
      .subscribe((data: any) => (
        this.rowData = data.content,
        this.collectiondata = data.content,
        this.collectionSize = data.totalElements,
        this.gridApi.applyTransaction({ add: this.rowData })));

  }
onRequests() {
  this.requestsVisible = true;
  this.loadRequests();
}

loadRequests() {
  const userType = this.type;
  this.unblockService.getUnblockRequests(userType).subscribe({
    next: (res: any) => {
      this.unblockRequests = Array.isArray(res.response.data) ? res.response.data : [];
      this.unblockRowData = [...this.unblockRequests];
 const start = (this.requestsCurrentPage - 1) * this.requestsPageSize;
      const end = start + this.requestsPageSize;
      this.unblockRowData = this.unblockRequests.slice(start, end);

      if (this.gridApi) {
        this.gridApi.setColumnDefs(this.unblockColumnDefs);
        this.gridApi.setRowData(this.unblockRowData);
      }
    },
    error: (err: any) => console.error('Error fetching unblock requests', err)
  });
}


  handleUnblockRequest(param: any) {
    this.selectedCustomer = param.data;
    this.unblockRequestInner.customerData = this.selectedCustomer;
    this.modalConfigUnblockRequestForm.modalTitle =
      this.permissions.includes('Approve')
        ? 'Approve Unblock Request'
        : 'Initiate Unblock Request';
    this.modalUnblockRequestComponent.open();
  }

  onRequestApproved() {
    this.modalUnblockRequestComponent.close();  // close modal
    this.loadRequests();               // refresh request table
  }

  onRequestRejected() {
    this.modalUnblockRequestComponent.close();
  }
  onExportCSV() {
    try {
      const today = new Date();
      const ref = today.getFullYear() + "-" +
        ("0" + (today.getMonth() + 1)).slice(-2) + "-" +
        ("0" + today.getDate()).slice(-2) + "_" +
        ("0" + today.getHours()).slice(-2) + "-" +
        ("0" + today.getMinutes()).slice(-2) + "-" +
        ("0" + today.getSeconds()).slice(-2);
      const fileName = `Blocked_Entities_${ref}`;
      const exportRowData: any[] = this.requestsVisible ? this.unblockRowData : this.rowData;
      if (!exportRowData || exportRowData.length === 0) {
        alert('No data to export');
        return;
      }
      if (!this.gridApi) {
        console.warn('Grid not ready yet.');
        return;
      }
      const exportRows: any[] = [];
      this.gridApi.forEachNodeAfterFilterAndSort((node: any) => {
        if (node?.data) exportRows.push(node.data);
      });

      if (!exportRows.length) {
        this.alertService?.errorAlertWithMessage?.("No records to export");
        return;
      }
      const headers = ((this.requestsVisible ? this.unblockColumnDefs : (this.tableSelectedColumn || this.columnDefs)) || [])
        .filter((c: any) => c?.field && !['actions', 'unblock', 'posRequest'].includes(c.field))
        .map((c: any) => ({ field: c.field, header: c.headerName || c.field }));
      const shaped: any[] = exportRows.map((r: any) => {
        const obj: any = {};
        headers.forEach(h => obj[h.field] = r[h.field] ?? '');
        return obj;
      });
      this.exportAsExcelFile(shaped, headers, fileName);

    } catch (err) {
      console.error('Export error', err);
      this.alertService?.errorAlertWithMessage?.("Export failed");
    }
  }

  public exportAsExcelFile(
    json: any[],
    headers: { field: string, header: string }[],
    excelFileName: string
  ): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([], {
      header: headers.map(h => h.field)
    });
    XLSX.utils.sheet_add_aoa(worksheet, [headers.map(h => h.header)]);
    XLSX.utils.sheet_add_json(worksheet, json, { origin: 'A2', skipHeader: true });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');

    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }


  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: EXCEL_TYPE });
    FileSaver.saveAs(data, fileName + new Date().getTime() + EXCEL_EXTENSION);
  }


}
